import { render, staticRenderFns } from "./FormFile.vue?vue&type=template&id=62a1267a&scoped=true"
import script from "./FormFile.vue?vue&type=script&lang=js"
export * from "./FormFile.vue?vue&type=script&lang=js"
import style0 from "./FormFile.vue?vue&type=style&index=0&id=62a1267a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a1267a",
  null
  
)

export default component.exports